// Supported languages. English is the default and lives at the root URL;
// every other language is served under its own prefix, e.g. /fr/about.
export const LANGUAGES = [
  { code: "en", label: "English", locale: "en-GB", dir: "ltr" },
  { code: "fr", label: "Français", locale: "fr-FR", dir: "ltr" },
  { code: "sw", label: "Kiswahili", locale: "sw-KE", dir: "ltr" },
  { code: "ar", label: "العربية", locale: "ar", dir: "rtl" },
];

export const DEFAULT_LANGUAGE = "en";

export const NAMESPACES = [
  "common",
  "home",
  "about",
  "projects",
  "resources",
  "articles",
  "contact",
];

export const isSupportedLanguage = (code) =>
  LANGUAGES.some((language) => language.code === code);

export const getLanguage = (code) =>
  LANGUAGES.find((language) => language.code === code) || LANGUAGES[0];

// "/fr/about" -> "fr", "/about" -> "en"
export const languageFromPath = (pathname) => {
  const first = pathname.split("/")[1];
  return isSupportedLanguage(first) && first !== DEFAULT_LANGUAGE
    ? first
    : DEFAULT_LANGUAGE;
};

// "/fr/about" -> "/about"
export const stripLanguage = (pathname) => {
  const language = languageFromPath(pathname);
  if (language === DEFAULT_LANGUAGE) return pathname || "/";
  return pathname.slice(language.length + 1) || "/";
};

// ("/about", "fr") -> "/fr/about"
export const localizePath = (path, language) => {
  if (!language || language === DEFAULT_LANGUAGE) return path;
  return path === "/" ? `/${language}` : `/${language}${path}`;
};
